import { memo } from "react";
import { useTranslate } from "helpers";
import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";
import VehicleExpenseRowChild from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleExpenseSearchPage/components/VehicleExpenseSearch/components/VehicleExpenseSearchResults/components/VehicleExpenseRowChild";
import { FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS } from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleExpenseSearchPage/components/VehicleExpenseSearch/components/VehicleExpenseSearchResults/consts";
import { FINANCE_EXPENSE_SEARCH_COLUMNS } from "./consts";
import { ExpenseSearchResultsProps } from "./types";

const ExpenseSearchResults: React.FC<ExpenseSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onVehicleClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={FINANCE_EXPENSE_SEARCH_COLUMNS(t, onDeleteClick, onVehicleClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
      onRowClick={onRowClick}
      columnsChild={FLEET_VEHICLE_EXPENSE_UPLOADS_SEARCH_COLUMNS(t)}
      CustomTableRowChild={(childProps) => (
        <VehicleExpenseRowChild
          {...childProps}
          onFetchSearchResult={() =>
            onPaginationChange?.(searchResults.pagination)
          }
        />
      )}
    />
  );
};

export default memo(ExpenseSearchResults);
